import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WINDOW_PROVIDERS } from '@kservice';

@NgModule({
  declarations: [],
  providers: [WINDOW_PROVIDERS],
  imports: [CommonModule],
})
export class CoreModule {}
